"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = exports.weights = exports.colors = void 0;
var baseColors = {
    astronaut: '#265976',
    atlantis: '#a6ce39',
    bahamaBlue: '#0661a3',
    bananaMania: '#FBDEB9',
    black: '#000000',
    blizzardBlue: '#aacfee',
    blueWhale: '#04304a',
    boulder: '#757575',
    cream: '#F0EFEC',
    curiousBlue: '#2B87BC',
    deco: '#C6DFAB',
    deepSeaBlue: '#0D4667',
    doveGray: '#6B6B6B',
    dustyGray: '#999999',
    jellyBean: '#2C7DAE',
    laPalma: '#17b410',
    linkWater: '#d7e9f5',
    lochmara: '#0973C0',
    lochmaraOnMercuryBackground: '#0769B1',
    mercury: '#E5E5E5',
    mineShaft: '#333333',
    monza: '#df0a14',
    morningGlory: '#95C3DD',
    olivedrab: '#6B8E23',
    pearlLusta: '#FCF8E3',
    pictonBlue: '#4ea3e1',
    pizazz: '#ff8c00',
    porcelain: '#e2e5e8',
    portica: '#f7eb5c',
    prussianBlue: '#003053',
    roman: '#dd5252',
    selago: '#e7f3fc',
    silver: '#ccc',
    silverChalice: '#aaaaaa',
    smaltBlue: '#567E95',
    submarine: '#B8BEC4',
    veniceBlue: '#055989',
    white: '#ffffff',
    wildSand: '#f5f5f5',
    zinnwaldite: '#EBAAAA'
};
exports.colors = __assign(__assign({}, baseColors), { textLight: baseColors.silverChalice, textMedium: baseColors.mineShaft, textSecondary: baseColors.boulder });
exports.weights = {
    bold: 700,
    light: 300,
    medium: 500,
    normal: 400
};
var theme = {
    colors: exports.colors,
    dropdowns: {
        background_color: exports.colors.white,
        background_color_highlight: exports.colors.selago,
        border_color: exports.colors.silver,
        box_shadow: '0 6px 12px rgba(0, 0, 0, 0.175)',
        color_disabled: exports.colors.boulder,
        label: {
            padding: '0 0.2em'
        }
    },
    forms: {
        checkbox: exports.colors.black,
        checkbox_disabled: exports.colors.boulder,
        checkbox_label_disabled_color: exports.colors.silverChalice,
        error_color: exports.colors.roman,
        input_border_color: exports.colors.boulder,
        input_border_required_color: exports.colors.pizazz,
        label_color_disabled: exports.colors.boulder,
        line_height: '1.5',
        text_color: exports.colors.black,
        text_color_disabled: exports.colors.boulder
    },
    loader: {
        color: exports.colors.boulder
    },
    modals: {
        borders: exports.colors.mercury,
        closeIcon: {
            color: exports.colors.boulder,
            weight: exports.weights.light
        },
        content: {
            backgroundColor: exports.colors.white,
            color: exports.colors.mineShaft
        },
        footer: {
            labelColor: exports.colors.boulder
        },
        horizontalPadding: '30px',
        overlay: {
            backgroundColor: 'rgba(11, 11, 11, 0.8)'
        },
        title: {
            size: '21px',
            weight: exports.weights.bold
        }
    },
    notifications: {
        backgroundColor: exports.colors.doveGray,
        borderErrorColor: exports.colors.roman,
        borderInfoColor: exports.colors.curiousBlue,
        borderSuccessColor: exports.colors.laPalma,
        borderWarningColor: exports.colors.pizazz,
        closeButtonColor: exports.colors.white,
        color: exports.colors.white
    },
    select: {
        group_border_bottom: "1px solid ".concat(exports.colors.mercury)
    },
    tables: {
        header: {
            border_color: exports.colors.silver
        }
    },
    tags: {
        background_color: exports.colors.blueWhale,
        border_color: exports.colors.blueWhale,
        clear_icon_color: exports.colors.white,
        heading_color: exports.colors.white,
        light: {
            border_color: exports.colors.mercury
        },
        subhead_color: exports.colors.submarine
    },
    weights: exports.weights,
    zindexes: ['dropdowns', 'dropdown-menu', 'small-floaters', 'modals', 'tooltips', 'modals-background']
};
exports.palette = [
    '#3A6782',
    '#E97216',
    '#A13A7E',
    '#43A287',
    '#795D25',
    '#6DA243',
    '#A93D32',
    '#BC73E7',
    '#404BE8',
    '#49A19E',
    '#419BD7',
    '#733708',
    '#DC6FB1',
    '#306E51',
    '#E2765F',
    '#4A6D27',
    '#B4902D',
    '#8435D9',
    '#828BF2',
    '#2B6E68'
];
exports.default = theme;
//# sourceMappingURL=radar.js.map